module.exports = __webpack_public_path__ + "img/contact-main.6561874d.png";